// Menu drawers controller

( function( $, window, document, undefined ) {

	let MenuDrawerController = class MenuDrawerController {
		constructor( $drawer, $button, $menu ) {
			const _ = this;

			_.$drawer = $drawer;
			_.$button = $button;
			_.$menu = $menu;

			_.animationSpeed = 300;
		}
	
		/**
		 * Open a menu drawer.
		 * @return {self} 
		 */
		open() {
			const _ = this;

			_.$menu.slideDown( _.animationSpeed, () => {
				// On complete
				$(document).trigger( 'menu-drawer-changed-state', [ _.$drawer, 'open' ] );
				_.$menu.attr( 'aria-hidden', 'false' );
			} );

			_.$drawer.addClass( 'is-open' );

			return _;
		}

		/**
		 * Close a menu drawer.
		 * @return {self} 
		 */
		close() {
			const _ = this;

			_.$menu.slideUp( _.animationSpeed, () => {
				$(document).trigger( 'menu-drawer-changed-state', [ _.$drawer, 'close' ] );

				_.$menu.attr( 'aria-hidden', 'true' );
				_.$drawer.removeClass( 'is-open' );
			} );

			return _;
		}

		/**
		 * Toggle a menu drawer between open and closed.
		 * @return {self} 
		 */
		toggle() {
			const _ = this;

			if ( _.isOpen() ) {
				_.close();
			} else {
				_.open();
			}

			return _;
		}

		/**
		 * Check if a menu drawer is open.
		 * @return {Boolean} 
		 */
		isOpen() {
			const _ = this;

			return _.$menu.is(':visible');
		}
	};

	window.MenuDrawerController = MenuDrawerController;
	
} )( jQuery, window, document );
